__turbopack_context__.v({
  "cardTitle": "FutureHomePlanner-module-scss-module__Z5S7Dq__cardTitle",
  "chartCard": "FutureHomePlanner-module-scss-module__Z5S7Dq__chartCard",
  "chartPlaceholder": "FutureHomePlanner-module-scss-module__Z5S7Dq__chartPlaceholder",
  "chartPlaceholderText": "FutureHomePlanner-module-scss-module__Z5S7Dq__chartPlaceholderText",
  "chartTitle": "FutureHomePlanner-module-scss-module__Z5S7Dq__chartTitle",
  "component": "FutureHomePlanner-module-scss-module__Z5S7Dq__component",
  "congratulationsCard": "FutureHomePlanner-module-scss-module__Z5S7Dq__congratulationsCard",
  "congratulationsText": "FutureHomePlanner-module-scss-module__Z5S7Dq__congratulationsText",
  "congratulationsTitle": "FutureHomePlanner-module-scss-module__Z5S7Dq__congratulationsTitle",
  "ctaButton": "FutureHomePlanner-module-scss-module__Z5S7Dq__ctaButton",
  "ctaCard": "FutureHomePlanner-module-scss-module__Z5S7Dq__ctaCard",
  "ctaContent": "FutureHomePlanner-module-scss-module__Z5S7Dq__ctaContent",
  "ctaDescription": "FutureHomePlanner-module-scss-module__Z5S7Dq__ctaDescription",
  "ctaFeature": "FutureHomePlanner-module-scss-module__Z5S7Dq__ctaFeature",
  "ctaFeatureContent": "FutureHomePlanner-module-scss-module__Z5S7Dq__ctaFeatureContent",
  "ctaFeatureDescription": "FutureHomePlanner-module-scss-module__Z5S7Dq__ctaFeatureDescription",
  "ctaFeatureDot": "FutureHomePlanner-module-scss-module__Z5S7Dq__ctaFeatureDot",
  "ctaFeatureTitle": "FutureHomePlanner-module-scss-module__Z5S7Dq__ctaFeatureTitle",
  "ctaFeatures": "FutureHomePlanner-module-scss-module__Z5S7Dq__ctaFeatures",
  "ctaIcon": "FutureHomePlanner-module-scss-module__Z5S7Dq__ctaIcon",
  "ctaIconContainer": "FutureHomePlanner-module-scss-module__Z5S7Dq__ctaIconContainer",
  "ctaTitle": "FutureHomePlanner-module-scss-module__Z5S7Dq__ctaTitle",
  "icon": "FutureHomePlanner-module-scss-module__Z5S7Dq__icon",
  "infoIcon": "FutureHomePlanner-module-scss-module__Z5S7Dq__infoIcon",
  "input": "FutureHomePlanner-module-scss-module__Z5S7Dq__input",
  "inputCard": "FutureHomePlanner-module-scss-module__Z5S7Dq__inputCard",
  "inputGroup": "FutureHomePlanner-module-scss-module__Z5S7Dq__inputGroup",
  "inputHeader": "FutureHomePlanner-module-scss-module__Z5S7Dq__inputHeader",
  "inputLabel": "FutureHomePlanner-module-scss-module__Z5S7Dq__inputLabel",
  "inputSection": "FutureHomePlanner-module-scss-module__Z5S7Dq__inputSection",
  "inputValue": "FutureHomePlanner-module-scss-module__Z5S7Dq__inputValue",
  "mainGrid": "FutureHomePlanner-module-scss-module__Z5S7Dq__mainGrid",
  "milestone": "FutureHomePlanner-module-scss-module__Z5S7Dq__milestone",
  "milestoneActive": "FutureHomePlanner-module-scss-module__Z5S7Dq__milestoneActive",
  "milestoneActiveAccent": "FutureHomePlanner-module-scss-module__Z5S7Dq__milestoneActiveAccent",
  "milestoneActiveBlue": "FutureHomePlanner-module-scss-module__Z5S7Dq__milestoneActiveBlue",
  "milestoneLabel": "FutureHomePlanner-module-scss-module__Z5S7Dq__milestoneLabel",
  "milestoneValue": "FutureHomePlanner-module-scss-module__Z5S7Dq__milestoneValue",
  "milestonesGrid": "FutureHomePlanner-module-scss-module__Z5S7Dq__milestonesGrid",
  "progressBar": "FutureHomePlanner-module-scss-module__Z5S7Dq__progressBar",
  "progressCard": "FutureHomePlanner-module-scss-module__Z5S7Dq__progressCard",
  "progressHeader": "FutureHomePlanner-module-scss-module__Z5S7Dq__progressHeader",
  "progressLabel": "FutureHomePlanner-module-scss-module__Z5S7Dq__progressLabel",
  "progressMessage": "FutureHomePlanner-module-scss-module__Z5S7Dq__progressMessage",
  "progressSection": "FutureHomePlanner-module-scss-module__Z5S7Dq__progressSection",
  "progressStatus": "FutureHomePlanner-module-scss-module__Z5S7Dq__progressStatus",
  "progressTitle": "FutureHomePlanner-module-scss-module__Z5S7Dq__progressTitle",
  "projectionAmount": "FutureHomePlanner-module-scss-module__Z5S7Dq__projectionAmount",
  "projectionAmountValue": "FutureHomePlanner-module-scss-module__Z5S7Dq__projectionAmountValue",
  "projectionCard": "FutureHomePlanner-module-scss-module__Z5S7Dq__projectionCard",
  "projectionColumn": "FutureHomePlanner-module-scss-module__Z5S7Dq__projectionColumn",
  "projectionContent": "FutureHomePlanner-module-scss-module__Z5S7Dq__projectionContent",
  "projectionFooter": "FutureHomePlanner-module-scss-module__Z5S7Dq__projectionFooter",
  "projectionFooterAccent": "FutureHomePlanner-module-scss-module__Z5S7Dq__projectionFooterAccent",
  "projectionFooterHighlight": "FutureHomePlanner-module-scss-module__Z5S7Dq__projectionFooterHighlight",
  "projectionFooterText": "FutureHomePlanner-module-scss-module__Z5S7Dq__projectionFooterText",
  "projectionStat": "FutureHomePlanner-module-scss-module__Z5S7Dq__projectionStat",
  "projectionStatLabel": "FutureHomePlanner-module-scss-module__Z5S7Dq__projectionStatLabel",
  "projectionStatValue": "FutureHomePlanner-module-scss-module__Z5S7Dq__projectionStatValue",
  "projectionStatValueAccent": "FutureHomePlanner-module-scss-module__Z5S7Dq__projectionStatValueAccent",
  "projectionStats": "FutureHomePlanner-module-scss-module__Z5S7Dq__projectionStats",
  "projectionSubtext": "FutureHomePlanner-module-scss-module__Z5S7Dq__projectionSubtext",
  "projectionTitle": "FutureHomePlanner-module-scss-module__Z5S7Dq__projectionTitle",
  "slider": "FutureHomePlanner-module-scss-module__Z5S7Dq__slider",
});
